// extracted by mini-css-extract-plugin
export default {"placeholders":"Placeholders_placeholders__w+tsI","placeholders_head":"Placeholders_placeholders_head__oaxwQ"};